export class ItemContratoInstrumentoCalibracao {
    constructor({
        dataUltimaCalibracao,
        quantidadeTotalCalibracao = null,
        valorTotalPontoServico = null,
        quantidadeTotalPontosCalibrarServico = null,
        quantidadePontosCalibrarAdicionalServico = null,
        valorTotalPontoAdicionalServico = null,
        quantidadeTotalPontos= null, 
        valorTotalCalibracao = null,
        flagRemovidoCliente = null,
        minimoPontos,
        valorPonto,
        data,
        valorServico,
        modoExibicao,
        label,
        descricao,
        servicoId,
        faixa,
    }) {
        this.dataUltimaCalibracao = dataUltimaCalibracao;
        this.servicoDescricao = modoExibicao == 'Nome' ? label : `${label}' '${descricao}`;
        this.servicoCodigo = data;
        this.quantidadeTotalCalibracao = quantidadeTotalCalibracao;
        this.valorUnitarioServico = valorServico;
        this.quantidadePontosCalibrarServico = minimoPontos;
        this.valorTotalPontoServico = valorTotalPontoServico;
        this.valorUnitarioPontoAdicionalServico = valorPonto;
        this.quantidadeTotalPontosCalibrarServico = quantidadeTotalPontosCalibrarServico || quantidadeTotalPontos;
        this.quantidadePontosCalibrarAdicionalServico = quantidadePontosCalibrarAdicionalServico;
        this.valorTotalPontoAdicionalServico = valorTotalPontoAdicionalServico;
        this.valorTotalCalibracao = valorTotalCalibracao;
        this.flagRemovidoCliente = flagRemovidoCliente;
        this.contratoInstrumentoServicoCalibracaoProximaCalibracao = [{ dataProximaCalibracao: null }];
        this.faixa = faixa;
        this.quantidadeTotalPontos = quantidadeTotalPontos;
        this.servicoId = servicoId;
    }
}